module.exports = __webpack_public_path__ + "static/media/002_docker_homepage_design_iteration2.79eebd21.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/docker/002_docker_homepage_design_iteration2.png
// module id = 381
// module chunks = 0